import React, { memo } from 'react';
import PropTypes from 'prop-types';

import styled, { css } from 'styled-components';
import { Col, Row, Separator, Text } from '@cuemath/comps';
import Link from 'comps/link';
import ProgramAnalytics from '../program-analytics';

const HeaderRow = styled(Row)`
  border-bottom: 1px solid ${({ theme: { COLORS } }) => COLORS.BORDER};
`;

const TabCol = styled(Col)`
  position: relative;
  min-width: 120px;

  ${({ selected, theme: { COLORS } }) =>
    selected &&
    css`
      &:after {
        position: absolute;
        content: '';
        left: 0;
        bottom: -3px;
        height: 3px;
        width: 100%;
        background: ${COLORS.PRIMARY};
      }
    `};
`;

const TabText = styled(Text)`
  line-height: 40px;
`;

function Tabs({ tabs, activeTab, programId, ...other }) {
  const tab = activeTab ? tabs.find(({ id }) => id === activeTab) : null;
  const { Component, id: activeTabId } = tab || tabs[0];

  return (
    <>
      <HeaderRow nowrap>
        {tabs.map(({ id, label, link }) => {
          const selectedTab = id === activeTabId;

          return (
            <TabCol selected={selectedTab} key={id}>
              <Link to={link}>
                <TabText
                  weight={selectedTab ? 'bold' : 'normal'}
                  type={selectedTab ? 'primary' : 'normal'}
                  align="center"
                >
                  {label}
                </TabText>
              </Link>
            </TabCol>
          );
        })}
      </HeaderRow>
      <Separator height={40} transparent />
      {!programId && <Component {...other} />}
      {programId && <ProgramAnalytics programId={programId} />}
    </>
  );
}

Tabs.propTypes = {
  activeTab: PropTypes.string.isRequired,
  programId: PropTypes.string,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      Component: PropTypes.any.isRequired,
    }),
  ).isRequired,
};

Tabs.defaultProps = {
  programId: null,
};

export default memo(Tabs);
